var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'background': true, [`background__${_vm.type}`]: true }},[_c('div',{class:{ [`background__overlap-${_vm.type}`]: true }}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }